/* eslint-disable */
// src/services/machineService.js

import axios from "services/axiosConfig";

const API_URL = "/api/machine";

// normalizador de payload para create/update de Machine
const normalizeMachinePayload = (machine = {}) => {
  const p = { ...machine };

  if (p.EliminatedDate && !p.EliminatedDateTime) {
    p.EliminatedDateTime = p.EliminatedDate;
  }
  delete p.EliminatedDate;

  return p;
};

class MachineService {
  // Crear una máquina con status available
  static async createMachine(machine) {
    const payload = normalizeMachinePayload(machine);
    const response = await axios.post(API_URL, payload);
    return response.data;
  }

  // Obtener todas las máquinas
  static async getMachines() {
    try {
      const response = await axios.get(API_URL);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas:", error);
      return [];
    }
  }

  // obtener todas las máquinas con sus tipos de máquina
  static async getAllMachinesWithDetails() {
    try {
      const response = await axios.get(`${API_URL}/details`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas con sus tipos de máquina:", error);
      return [];
    }
  }

  // obtener todas las máquinas con sus tipos de máquinas donde status Available
  static async getAvailableMachinesWithDetails() {
    try {
      const response = await axios.get(`${API_URL}/available`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas disponibles (con detalles):", error);
      return [];
    }
  }

  // obtener todas las máquinas con sus tipos de máquinas donde status eliminated
  static async getEliminatedMachinesWithDetails() {
    try {
      const response = await axios.get(`${API_URL}/eliminated`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas eliminadas (con detalles):", error);
      return [];
    }
  }

  // obtener todas las máquinas con sus tipos de máquinas donde status inUse
  static async getInUseMachinesWithDetails() {
    try {
      const response = await axios.get(`${API_URL}/inuse`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener las máquinas en uso (con detalles):", error);
      return [];
    }
  }

  // Obtener una máquina por id
  static async getMachineById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener la máquina por ID:", error);
      return null;
    }
  }

    // Obtener una máquina por id CON details (DTO igual a /available)
  static async getMachineByIdWithDetails(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}/details`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener la máquina por ID (con details):", error);
      return null;
    }
  }

  static async getSerialSuggestion(machineTypeId) {
  try {
    const res = await axios.get(`${API_URL}/serial/suggestion`, {
      params: { machineTypeId: Number(machineTypeId) },
    });
    return res.data?.suggestion ?? null;
  } catch (e) {
    console.error("Error obteniendo sugerencia serial:", e);
    return null;
  }
}

static async serialExists(serial, excludeId = null) {
  try {
    const params = { serial };
    if (excludeId) params.excludeId = Number(excludeId);

    const res = await axios.get(`${API_URL}/serial/exists`, { params });
    return !!res.data?.exists;
  } catch (e) {
    console.error("Error validando serial:", e);
    return false;
  }
}

  // Actualizar una máquina
  static async updateMachine(id, machine) {
    try {
      const payload = normalizeMachinePayload(machine);
      const response = await axios.put(`${API_URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error al editar la máquina:", error);
      return null;
    }
  }

  // (Soft-delete) modificar atributo status y lo pone eliminated, y pone EliminatedDate=now() 
  static async deleteMachine(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`);
      return response.status === 204;
    } catch (error) {
      console.error("Error al eliminar la máquina:", error);
      return false;
    }
  }

  // Reactivar (status Eliminated → Available)
  static async reactivateMachine(id) {
    try {
      const response = await axios.patch(`${API_URL}/${id}/reactivate`);
      return response.status === 204;
    } catch (error) {
      console.error("Error al reactivar la máquina:", error);
      return false;
    }
  }

  static async moveMachineBetweenDepositos(machineId, fromLocalId, toLocalId, EffectiveDate) {
    try {
    const payload = {
      fromLocalId: Number(fromLocalId),
      toLocalId: Number(toLocalId),
      EffectiveDate,
    };

    const response = await axios.post(
      `${API_URL}/${machineId}/move-deposito`,
      payload
    );
    return { ok: response.status === 200 };
  } catch (error) {
    console.error("Error al mover la máquina entre depósitos:", error);
    if (error.response) {
      return {
        ok: false,
        status: error.response.status,
        code: error.response.data?.code || null,
        message: error.response.data?.error || "Error moviendo la máquina.",
      };
    }
    return { ok: false, message: "Error de red moviendo la máquina." };
  }
  }

}

export default MachineService;
